import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import pemFile from '../../mfa_keys/logingov.npe.pem';

const CallbackLoginGov = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { login, setLoginError } = useAuth();

  useEffect(() => {
    const handleCallback = async () => {
      const params = new URLSearchParams(location.search);
      const code = params.get('code');
      const state = params.get('state');
      const error = params.get('error');
      const errorDescription = params.get('error_description');

      // Handle OAuth error
      if (error) {
        setLoginError(`${error}: ${errorDescription || 'No error description provided.'}`);
        return navigate('/login');
      }

      const storedState = sessionStorage.getItem('state');
      if (!code || !state || state !== storedState) {
        setLoginError('Invalid or missing code/state from Login.gov');
        return navigate('/login');
      }

      // Exchange the code for a token
      try {
        const response = await fetch(`/api/auth/logingov`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            code: code,
          }),
        });
        const tokenResponse = await response.json();

        if (response.status === 200) {
          console.log('Token exchange successful:', tokenResponse);
          const { email, roles, userState, data } = tokenResponse;
          login(data.id_token, email, roles, userState);
          setLoginError(null);
          navigate('/');
        } else {
          console.error('Token exchange failed:', tokenResponse);
          const errorMessage = tokenResponse?.error?.message || tokenResponse?.message || `Login failed (${response.status})`;
          setLoginError(errorMessage);
          navigate('/login');
        }
      } catch (err) {
        console.error('Login.gov token exchange error:', err);
        setLoginError('Network error during login. Please check your connection and try again.');
        navigate('/login');
      }
    };

    handleCallback();
  }, [location.search, login, navigate, setLoginError]);

  return <div>Processing Login.gov authentication...</div>;
};

export default CallbackLoginGov;
